import PropTypes from "prop-types";
import React from "react";
import Expandable from "web/react/components/expandable/expandable";
import Shipping from "web/react/components/shipping/shipping";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./product-description-shipping.css";

function ProductDescriptionShipping(_ref) {
  var className = _ref.className,
      expressShipping = _ref.expressShipping,
      freeReturn = _ref.freeReturn,
      freeShipping = _ref.freeShipping,
      leadUrl = _ref.leadUrl,
      productAreaAccordions = _ref.productAreaAccordions,
      retailerName = _ref.retailerName,
      linkId = _ref.linkId;
  return productAreaAccordions ? React.createElement("div", {
    className: className
  }, React.createElement(Expandable, {
    renderLabel: function renderLabel() {
      return React.createElement("h4", null, gettext("in_stock_product.compare_prices.all_shipping_returns.link"));
    },
    onClick: function onClick(isOpen) {
      if (!isOpen) {
        analytics.event("product area", "click", "open-shipping");
      }
    }
  }, React.createElement(Shipping, {
    freeShippingUrl: ""
    /* this is always "" in monoprice_buy_option.py */
    ,
    leadUrl: leadUrl,
    retailerName: retailerName,
    freeShipping: freeShipping,
    freeReturn: freeReturn,
    expressShipping: expressShipping,
    linkId: linkId
  }))) : React.createElement("div", {
    className: className
  }, React.createElement("h4", {
    className: styles.shippingTitle
  }, gettext("in_stock_product.shipping_returns_label")), React.createElement(Shipping, {
    freeShippingUrl: "",
    leadUrl: leadUrl,
    retailerName: retailerName,
    freeShipping: freeShipping,
    freeReturn: freeReturn,
    expressShipping: expressShipping,
    linkId: linkId
  }));
}

ProductDescriptionShipping.propTypes = {
  className: PropTypes.string,
  expressShipping: ShippingOptionPropType,
  freeReturn: PropTypes.bool,
  freeShipping: ShippingOptionPropType,
  leadUrl: PropTypes.string,
  productAreaAccordions: PropTypes.bool,
  retailerName: PropTypes.string,
  linkId: PropTypes.string
};
export default ProductDescriptionShipping;